// extracted by mini-css-extract-plugin
export var actions = "_c-4";
export var brand = "_c-3";
export var header = "_c-0";
export var headerContent = "_c-1";
export var identity = "_c-5";
export var logo = "_c-2";